import { Component, ErrorInfo, ReactNode } from 'react'
import { Box } from '@material-ui/core'
import { navigate } from '@reach/router';
import Header from "../src/organisms/Header/Header"
interface Props {
    children: ReactNode
}

interface State {
    hasError: boolean
    error?: any
    errorInfo?: any
}

const appEnv = process.env["REACT_APP_DEVELOPMENT_ENVIRONMENT"]

class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = { hasError: false }
    }

    public static getDerivedStateFromError(error: Error): State {
        // Update state so the next render will show the fallback UI.
        console.log(error)
        return { hasError: true }
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        this.setState({ error, errorInfo })
        return { hasError: true, error, errorInfo }
    }

    public handleContinueClick = () => {
        this.setState({ hasError: false })
        navigate(-1)
    }

    public render() {
        const { hasError } = this.state
        if (hasError) {
            const { error, errorInfo } = this.state
            let errorStackMsg = ''
            let errorInfoMsg = ''
            let errorToString = ''
            if (error) {
                errorToString = error.toString()
                errorStackMsg = error.stack
                console.log(error)
            }

            if (errorInfo) {
                errorInfoMsg = JSON.stringify(errorInfo)
            }
            return (
                <>
                <Header backNav={false} progressValue={ 0} showPhone={false} />
                <div className="error-page" style={{marginTop:'40%'}}>
                    {appEnv === "development" && <>
                        <h1>
                            {' '}
                            Please report this problem with support team. Once
                            reported
                            <button
                                type="button"
                                onClick={() => {
                                    this.handleContinueClick()
                                }}
                            >
                                {' '}
                                click here to continue
                            </button>
                        </h1>

                        <hr />
                        {errorToString}
                        <hr />
                        {errorStackMsg}
                        <hr />
                        {errorInfoMsg}
                    </>}

                    {appEnv === "production" && <Box display={'flex'} justifyContent={'center'}
                    alignItems='center' padding={10} textAlign={'center'}><h1>{' '} Please start the form again from the text message you received</h1><hr/></Box>}
                    
                </div>
                </>
            )
        }

        const { children } = this.props
        return children
    }
}

export default ErrorBoundary
